export const ATTENDANCE_MODE = {
  IN_PERSON: 0,
  BOTH: 1,
  ONLINE_ONLY: 2,
} as const;

export type AttendanceMode =
  typeof ATTENDANCE_MODE[keyof typeof ATTENDANCE_MODE];

export function allowsOnline(mode: AttendanceMode | null | undefined): boolean {
  return mode === ATTENDANCE_MODE.BOTH || mode === ATTENDANCE_MODE.ONLINE_ONLY;
}

export function allowsInPerson(
  mode: AttendanceMode | null | undefined,
): boolean {
  return mode === ATTENDANCE_MODE.IN_PERSON || mode === ATTENDANCE_MODE.BOTH;
}
